import { buildRoute } from '@direct-frontend/modules-router';

export type BadgeParams = { badgeId: string };
export const BADGE_ID_NEW = 'new' as const;
export const badgeRoute = buildRoute<BadgeParams>('/badge/:badgeId');
